import React from 'react';
import { IFooterTab, Tabs } from '../../Tabs';
import { SUB_TABS_IMAGE } from './constants';
import { useSelector } from 'react-redux';
import { useLayerSettings } from '../../../RightWorkArea/useLayerSetting';

interface ISettingsLayers {

}

export const SettingsLayers = (props: ISettingsLayers) => {

    const settingHandler = useLayerSettings();

    const tabs: IFooterTab[] = [
        {
            imageSrc: "./assets/img/icons/copy_icn.svg",
            title: SUB_TABS_IMAGE.DUPLICATE.title,
            ...settingHandler.duplicate
        },
        {
            imageSrc: "./assets/img/icons/flip_v.svg",
            title: SUB_TABS_IMAGE.FLIP_V.title,
            ...settingHandler.flip_v
        },
        {
            imageSrc: "./assets/img/icons/flip_h.svg",
            title: SUB_TABS_IMAGE.FLIP_H.title,
            ...settingHandler.flip_h
        },
        {
            imageSrc: "./assets/img/icons/align_l.svg",
            title: SUB_TABS_IMAGE.ALIGN_LEFT.title,
            ...settingHandler.alignLeft
        },
        {
            imageSrc: "./assets/img/icons/align_r.svg",
            title: SUB_TABS_IMAGE.ALIGN_RIGHT.title,
            ...settingHandler.alignRight
        },
        {
            imageSrc: "./assets/img/icons/align_c.svg",
            title: SUB_TABS_IMAGE.ALIGN_CENTER.title,
            ...settingHandler.alignCenter
        },
        {
            imageSrc: "./assets/img/icons/align_t.svg",
            title: SUB_TABS_IMAGE.ALIGN_TOP.title,
            ...settingHandler.alignTop
        },
        {
            imageSrc: "./assets/img/icons/align_b.svg",
            title: SUB_TABS_IMAGE.ALIGN_BOTTOM.title,
            ...settingHandler.alignBottom
        },
        {
            imageSrc: "./assets/img/icons/bring_front_icn.svg",
            title: SUB_TABS_IMAGE.BRING_FRONT.title,
            ...settingHandler.bringToFront
        },
        {
            imageSrc: "./assets/img/icons/send_back_icn.svg",
            title: SUB_TABS_IMAGE.SEND_BACK.title,
            ...settingHandler.sendToBack
        }
    ]
    return <Tabs mainTabItems={tabs}/>
}